// Toxane Beauty - Main JavaScript

// ===== CART FUNCTIONALITY =====
let cart = {
  items: [],
  count: 0
};

// Update cart display
function updateCartDisplay() {
  const cartLink = document.querySelector('.cart-link');
  if (cartLink) {
    cartLink.textContent = `Cart(${cart.count})`;
  }
}

// Add to cart
function addToCart(productName, price) {
  cart.items.push({ name: productName, price: price });
  cart.count++;
  updateCartDisplay();

  // Show notification (simple alert for now)
  showNotification(`${productName} added to cart!`);
}

// Show notification
function showNotification(message) {
  const notification = document.createElement('div');
  notification.className = 'notification';
  notification.textContent = message;
  notification.style.cssText = `
    position: fixed;
    bottom: 30px;
    right: 30px;
    background-color: #000;
    color: #fff;
    padding: 20px 30px;
    border-radius: 46px;
    font-size: 18px;
    z-index: 1000;
    animation: slideIn 0.3s ease;
  `;

  document.body.appendChild(notification);

  setTimeout(() => {
    notification.style.animation = 'slideOut 0.3s ease';
    setTimeout(() => {
      document.body.removeChild(notification);
    }, 300);
  }, 3000);
}

// Add animation styles
const style = document.createElement('style');
style.textContent = `
  @keyframes slideIn {
    from {
      transform: translateX(400px);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
  
  @keyframes slideOut {
    from {
      transform: translateX(0);
      opacity: 1;
    }
    to {
      transform: translateX(400px);
      opacity: 0;
    }
  }
`;
document.head.appendChild(style);

// ===== PRODUCT COLLECTION TABS =====
document.addEventListener('DOMContentLoaded', function () {
  const tabButtons = document.querySelectorAll('.tab-button');
  const collections = document.querySelectorAll('.product-collection');

  function switchCollection(targetTab) {
    // Remove active class from all buttons
    tabButtons.forEach(btn => btn.classList.remove('active'));

    // Add active class to clicked button
    const activeButton = document.querySelector(`[data-tab="${targetTab}"]`);
    if (activeButton) {
      activeButton.classList.add('active');
    }

    // Animate collection switch
    collections.forEach(collection => {
      const collectionName = collection.getAttribute('data-collection');

      if (collectionName === targetTab) {
        // Remove active from all collections first
        collections.forEach(c => c.classList.remove('active'));

        // Small delay to ensure fade out starts
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            collection.classList.add('active');
          });
        });
      } else {
        // Hide current collection with animation
        collection.classList.remove('active');
      }
    });
  }

  tabButtons.forEach(button => {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      const targetTab = this.getAttribute('data-tab');
      if (targetTab) {
        switchCollection(targetTab);
      }
    });
  });
});

// ===== ADD TO CART BUTTONS =====
document.addEventListener('DOMContentLoaded', function () {
  const addButtons = document.querySelectorAll('.btn-add');

  addButtons.forEach((button, index) => {
    button.addEventListener('click', function () {
      const productCard = this.closest('.product-card');
      const productName = productCard.querySelector('.product-title').textContent;
      const productPrice = productCard.querySelector('.product-price').textContent;

      addToCart(productName, productPrice);
    });
  });
});

// ===== STICKY HEADER =====
window.addEventListener('scroll', function () {
  const header = document.querySelector('.site-header');

  if (window.scrollY > 100) {
    header.classList.add('scrolled');
  } else {
    header.classList.remove('scrolled');
  }
});

// ===== NEWSLETTER FORM =====
document.addEventListener('DOMContentLoaded', function () {
  const newsletterForm = document.querySelector('.newsletter-form');

  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function (e) {
      e.preventDefault();

      const email = this.querySelector('input[type="email"]').value;

      // Simulate form submission
      showNotification(`Thank you for subscribing with ${email}!`);

      // Reset form
      this.reset();
    });
  }
});

// ===== SMOOTH SCROLL FOR ANCHOR LINKS =====
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    const href = this.getAttribute('href');

    // Don't prevent default for empty anchors or cart/signin
    if (href === '#' || href === '#cart' || href === '#signin') {
      return;
    }

    e.preventDefault();

    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
});

// ===== MOBILE MENU TOGGLE =====
function initMobileMenu() {
  const menuToggle = document.querySelector('.menu-toggle');
  const menuClose = document.querySelector('.mobile-menu-close');
  const mobileMenu = document.getElementById('mobile-menu');
  const body = document.body;

  if (!menuToggle || !menuClose || !mobileMenu) return;

  function openMenu() {
    mobileMenu.classList.add('active');
    body.style.overflow = 'hidden';
  }

  function closeMenu() {
    mobileMenu.classList.remove('active');
    body.style.overflow = '';
  }

  menuToggle.addEventListener('click', openMenu);
  menuClose.addEventListener('click', closeMenu);

  // Close menu when clicking on overlay (but not on content)
  mobileMenu.addEventListener('click', function(e) {
    if (e.target === mobileMenu) {
      closeMenu();
    }
  });

  // Close menu when clicking on menu links
  const menuLinks = mobileMenu.querySelectorAll('.mobile-menu-link, .mobile-menu-button');
  menuLinks.forEach(link => {
    link.addEventListener('click', closeMenu);
  });
}

// Initialize mobile menu when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMobileMenu);
} else {
  initMobileMenu();
}

// ===== INTERSECTION OBSERVER FOR ANIMATIONS =====
const observerOptions = {
  threshold: 0.1,
  rootMargin: '0px 0px -100px 0px'
};

const observer = new IntersectionObserver(function (entries) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.style.opacity = '1';
      entry.target.style.transform = 'translateY(0)';
    }
  });
}, observerOptions);

// Observe elements on page load
document.addEventListener('DOMContentLoaded', function () {
  const animatedElements = document.querySelectorAll('.product-card, .category-card');

  animatedElements.forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(30px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    observer.observe(el);
  });
});

// ===== GLASSMORPHISM CURSOR FOR PRODUCT GRID =====
(function () {
  'use strict';

  // Only run on desktop (hover support)
  if (window.matchMedia('(hover: none)').matches) {
    return;
  }

  // Wait for DOM to be ready
  function initGlassCursor() {
    const cursor = document.querySelector('.glass-cursor');
    if (!cursor) {
      console.warn('Glass cursor element not found');
      return;
    }

    // Smooth following (lerp)
    let x = window.innerWidth / 2;
    let y = window.innerHeight / 2;
    let targetX = x;
    let targetY = y;

    // Initialize cursor position (center of cursor at mouse position)
    cursor.style.left = `${x}px`;
    cursor.style.top = `${y}px`;
    cursor.style.transform = 'translate(-50%, -50%)';

    // Update cursor position on mouse move
    document.addEventListener('mousemove', (e) => {
      targetX = e.clientX;
      targetY = e.clientY;
    });

    // Smooth animation loop
    function animate() {
      // Lerp interpolation (0.15 = smoothness factor)
      x += (targetX - x) * 0.15;
      y += (targetY - y) * 0.15;

      // Position center of cursor at (x, y)
      cursor.style.left = `${x}px`;
      cursor.style.top = `${y}px`;
      requestAnimationFrame(animate);
    }

    animate();

    // Activate cursor only on product-grid sections
    function setupGridHover() {
      const collectionsWrapper = document.querySelector('.product-collections-wrapper');
      if (!collectionsWrapper) {
        console.warn('No .product-collections-wrapper found');
        return;
      }

      // Track if we're inside an active product-grid
      let isInsideGrid = false;

      // Use mouseenter/mouseleave on the wrapper for better performance
      collectionsWrapper.addEventListener('mouseenter', (e) => {
        // Check if we're over an active product-grid
        const activeGrid = collectionsWrapper.querySelector('.product-collection.active .product-grid');
        if (activeGrid) {
          isInsideGrid = true;
          cursor.style.opacity = '1';
          document.body.classList.add('glass-cursor-active');
        }
      });

      collectionsWrapper.addEventListener('mouseleave', (e) => {
        isInsideGrid = false;
        cursor.style.opacity = '0';
        document.body.classList.remove('glass-cursor-active');
      });

      // Also check on mousemove for dynamic updates
      collectionsWrapper.addEventListener('mousemove', (e) => {
        const activeGrid = collectionsWrapper.querySelector('.product-collection.active .product-grid');
        const isOverActiveGrid = activeGrid && activeGrid.contains(e.target);

        // Check if we're over a button (btn-add or btn-add--black)
        const isOverButton = e.target.closest('.btn-add, .btn-add--black');

        if (isOverButton) {
          // Hide custom cursor and show native cursor on buttons
          isInsideGrid = false;
          cursor.style.opacity = '0';
          document.body.classList.remove('glass-cursor-active');
        } else if (isOverActiveGrid && !isInsideGrid) {
          isInsideGrid = true;
          cursor.style.opacity = '1';
          document.body.classList.add('glass-cursor-active');
        } else if (!isOverActiveGrid && isInsideGrid) {
          isInsideGrid = false;
          cursor.style.opacity = '0';
          document.body.classList.remove('glass-cursor-active');
        }
      });

      // Also handle button hover separately for better control
      const buttons = collectionsWrapper.querySelectorAll('.btn-add, .btn-add--black');
      buttons.forEach(button => {
        button.addEventListener('mouseenter', () => {
          cursor.style.opacity = '0';
          document.body.classList.remove('glass-cursor-active');
        });

        button.addEventListener('mouseleave', (e) => {
          // Only restore cursor if we're still over the grid (not leaving it)
          const activeGrid = collectionsWrapper.querySelector('.product-collection.active .product-grid');
          if (activeGrid && activeGrid.contains(e.relatedTarget)) {
            cursor.style.opacity = '1';
            document.body.classList.add('glass-cursor-active');
          }
        });
      });
    }

    // Setup hover immediately
    setupGridHover();

    // Also setup after a short delay to catch dynamically loaded content
    setTimeout(setupGridHover, 100);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGlassCursor);
  } else {
    initGlassCursor();
  }
})();

// ===== ACCORDION FUNCTIONALITY =====
(function () {
  'use strict';

  function initAccordions() {
    const accordionItems = document.querySelectorAll('[data-accordion-item]');

    accordionItems.forEach(item => {
      const header = item.querySelector('.accordion-header');
      const body = item.querySelector('.accordion-body');
      const containerId = item.getAttribute('data-container-id');

      if (!header || !body) return;

      header.addEventListener('click', function () {
        const isOpen = item.classList.contains('accordion-item--open');

        // Close all other accordions in the same container
        if (containerId) {
          const container = document.getElementById(containerId);
          if (container) {
            const siblings = container.querySelectorAll('[data-accordion-item]');
            siblings.forEach(sibling => {
              if (sibling !== item && sibling.classList.contains('accordion-item--open')) {
                closeAccordion(sibling);
              }
            });
          }
        }

        // Toggle current accordion
        if (isOpen) {
          closeAccordion(item);
        } else {
          openAccordion(item);
        }
      });
    });
  }

  function openAccordion(item) {
    const body = item.querySelector('.accordion-body');
    const header = item.querySelector('.accordion-header');

    if (!body || !header) return;

    // Set aria attributes
    header.setAttribute('aria-expanded', 'true');
    body.setAttribute('aria-hidden', 'false');

    // Temporarily set max-height to 0 to get accurate scrollHeight
    body.style.maxHeight = '0px';

    // Get actual content height
    const content = body.querySelector('.accordion-content');
    if (content) {
      // Force reflow to get accurate height
      void body.offsetHeight;

      const contentHeight = content.scrollHeight;

      // Add open class
      item.classList.add('accordion-item--open');

      // Set max-height to actual content height for smooth animation
      // Use requestAnimationFrame to ensure transition works
      requestAnimationFrame(() => {
        body.style.maxHeight = contentHeight + 40 + 'px'; // Add padding
      });
    } else {
      item.classList.add('accordion-item--open');
    }
  }

  function closeAccordion(item) {
    const body = item.querySelector('.accordion-body');
    const header = item.querySelector('.accordion-header');

    if (!body || !header) return;

    // Set aria attributes
    header.setAttribute('aria-expanded', 'false');
    body.setAttribute('aria-hidden', 'true');

    // Remove open class
    item.classList.remove('accordion-item--open');

    // Reset max-height
    body.style.maxHeight = '0';
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordions);
  } else {
    initAccordions();
  }
})();

// ===== CONSOLE BRANDING =====
console.log('%c Toxane Beauty ', 'background: #ffbf00; color: #000; font-size: 20px; font-weight: bold; padding: 10px;');
console.log('%c Luxury within reach, every day ', 'font-size: 14px; color: #666;');
